import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const PendingApprovalCard = ({ approval, onApprove, onReject, onDelegate }) => {
  const entityTypeLabels = {
    leave_request: 'Leave Request',
    payroll_batch: 'Payroll Batch',
    contract: 'Contract',
    expense: 'Expense'
  };

  const getTimeRemaining = (timeoutAt) => {
    if (!timeoutAt) return null;
    const now = new Date();
    const timeout = new Date(timeoutAt);
    const diff = timeout - now;
    
    if (diff < 0) return 'Overdue';
    
    const hours = Math.floor(diff / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    
    if (hours > 24) {
      return `${Math.floor(hours / 24)} days remaining`;
    }
    return `${hours}h ${minutes}m remaining`;
  };

  const timeRemaining = getTimeRemaining(approval?.timeoutAt);
  const isOverdue = timeRemaining === 'Overdue';

  return (
    <div className={`bg-card rounded-lg border p-6 ${
      isOverdue ? 'border-error' : 'border-border'
    }`}>
      <div className="flex items-start justify-between mb-4">
        <div className="flex-1">
          <div className="flex items-center gap-3 mb-2">
            <h3 className="text-lg font-semibold text-foreground">
              {approval?.stepName}
            </h3>
            <span className="px-2 py-1 bg-primary/10 text-primary text-xs rounded">
              Step {approval?.stepOrder}
            </span>
          </div>
          <p className="text-sm text-muted-foreground mb-3">
            {entityTypeLabels?.[approval?.entityType] || approval?.entityType}
          </p>
          <div className="flex items-center gap-4 text-xs text-muted-foreground mb-3">
            <span className="flex items-center gap-1">
              <Icon name="User" size={14} />
              Initiated by {approval?.initiatedBy}
            </span>
            <span className="flex items-center gap-1">
              <Icon name="Calendar" size={14} />
              {new Date(approval?.initiatedAt)?.toLocaleDateString()}
            </span>
          </div>
          {approval?.entityMetadata && (
            <div className="grid grid-cols-2 gap-3 mb-3">
              {approval?.entityMetadata?.department && (
                <div>
                  <p className="text-xs text-muted-foreground mb-1">Department</p>
                  <p className="text-sm text-foreground font-medium">{approval?.entityMetadata?.department}</p>
                </div>
              )}
              {approval?.entityMetadata?.amount && (
                <div>
                  <p className="text-xs text-muted-foreground mb-1">Amount</p>
                  <p className="text-sm text-foreground font-medium">K{approval?.entityMetadata?.amount?.toLocaleString()}</p>
                </div>
              )}
              {approval?.entityMetadata?.leave_type && (
                <div>
                  <p className="text-xs text-muted-foreground mb-1">Leave Type</p>
                  <p className="text-sm text-foreground font-medium">{approval?.entityMetadata?.leave_type}</p>
                </div>
              )}
              {approval?.entityMetadata?.days && (
                <div>
                  <p className="text-xs text-muted-foreground mb-1">Days</p>
                  <p className="text-sm text-foreground font-medium">{approval?.entityMetadata?.days} days</p>
                </div>
              )}
            </div>
          )}
          {timeRemaining && (
            <div className={`flex items-center gap-2 px-3 py-2 rounded ${
              isOverdue ? 'bg-error/10 text-error' : 'bg-warning/10 text-warning'
            }`}>
              <Icon name="Clock" size={16} />
              <span className="text-sm font-medium">{timeRemaining}</span>
            </div>
          )}
        </div>
      </div>
      <div className="flex items-center gap-3 pt-4 border-t border-border">
        <Button
          variant="primary"
          size="sm"
          iconName="CheckCircle"
          onClick={() => onApprove?.(approval)}
        >
          Approve
        </Button>
        <Button
          variant="outline"
          size="sm"
          iconName="XCircle"
          onClick={() => onReject?.(approval)}
        >
          Reject
        </Button>
        <Button
          variant="outline"
          size="sm"
          iconName="UserPlus"
          onClick={() => onDelegate?.(approval)}
        >
          Delegate
        </Button>
      </div>
    </div>
  );
};

export default PendingApprovalCard;